import groupService from '../../../services/api/matGroupService';
import schoolService from '../../../services/api/schoolService';

// Each factory holds one archive action: confirmation copy, service call and outcome toasts.

const archiveMatMessage = (matName, activeSchoolCount) => {
  if (activeSchoolCount === 0) return `Archive ${matName}?`;
  if (activeSchoolCount === 1) return `Archive ${matName} and its 1 school?`;
  if (activeSchoolCount == null) return `Archive ${matName} and all its schools?`;
  return `Archive ${matName} and its ${activeSchoolCount} schools?`;
};

export const archiveMatAction = ({ matId, matName, activeSchoolCount }) => ({
  title: 'Archive MAT',
  confirmLabel: 'Archive',
  destructive: true,
  message: archiveMatMessage(matName || 'this MAT', activeSchoolCount),
  perform: () => groupService.archiveGroup(matId),
  successMessage: 'MAT archived.',
  failureMessage: "Couldn't archive MAT.",
});

export const unarchiveMatAction = ({ matId, matName }) => ({
  title: 'Unarchive MAT',
  confirmLabel: 'Unarchive',
  destructive: false,
  message: `Unarchive ${matName || 'this MAT'}? Its schools stay archived.`,
  perform: () => groupService.unarchiveGroup(matId),
  successMessage: 'MAT unarchived.',
  failureMessage: "Couldn't unarchive MAT.",
});

export const archiveSchoolAction = ({ schoolId }) => ({
  title: 'Archive school',
  confirmLabel: 'Archive',
  destructive: true,
  message: 'Archive this school?',
  perform: () => schoolService.archiveSchool(schoolId),
  successMessage: 'School archived.',
  failureMessage: "Couldn't archive school.",
});

export const unarchiveSchoolAction = ({ schoolId }) => ({
  title: 'Unarchive school',
  confirmLabel: 'Unarchive',
  destructive: false,
  message: 'Unarchive this school?',
  perform: () => schoolService.unarchiveSchool(schoolId),
  successMessage: 'School unarchived.',
  failureMessage: "Couldn't unarchive school.",
});
